module.exports = __webpack_public_path__ + "public/img/en_us.80cbecd2.png";